import React, { useState, useEffect } from 'react';
import './DonatePage_NEW.css';
import AdminPanel from './AdminPanel';
import './AdminPanel.css';

interface DonatePageProps {
  onClose: () => void;
}

interface SocialLink {
  id: string;
  name: string;
  url: string;
  icon: string;
}

const DonatePage: React.FC<DonatePageProps> = ({ onClose }) => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [showAdminPanel, setShowAdminPanel] = useState(false);
  const [adminClickCount, setAdminClickCount] = useState(0);

  const [categories, setCategories] = useState([
    { id: 'all', name: 'Tüm Ürünler', icon: '🛍️' },
    { id: 'vip', name: 'VIP Paketleri', icon: '👑' },
    { id: 'money', name: 'Oyun İçi Para', icon: '💰' },
    { id: 'vehicles', name: 'Araçlar', icon: '🚗' },
    { id: 'houses', name: 'Evler', icon: '🏠' },
    { id: 'items', name: 'Özel Eşyalar', icon: '🎁' }
  ]);

  const [products, setProducts] = useState([
    {
      id: 1,
      category: 'vip',
      image: '/gta.png',
      title: 'Bronz VIP',
      description: 'Temel VIP özellikleri',
      price: '₺25',
      features: ['Özel Rozet', 'VIP Chat', '50K Para']
    },
    {
      id: 2,
      category: 'vip',
      image: '/fivem.png',
      title: 'Gümüş VIP',
      description: 'Gelişmiş VIP özellikleri',
      price: '₺50',
      features: ['Gümüş Rozet', 'Premium Chat', '100K Para']
    },
    {
      id: 3,
      category: 'vip',
      image: '/discord.png',
      title: 'Altın VIP',
      description: 'En üst seviye VIP',
      price: '₺100',
      features: ['Altın Rozet', 'Elite Chat', '250K Para']
    }
  ]);

  const [socialLinks, setSocialLinks] = useState<SocialLink[]>([]);

  // LocalStorage'dan veri yükle
  useEffect(() => {
    console.log('DonatePage: LocalStorage verilerini yüklüyor...');
    
    const savedCategories = localStorage.getItem('vise-categories');
    const savedProducts = localStorage.getItem('vise-products');
    const savedSocialLinks = localStorage.getItem('vise-social-links');
    
    if (savedCategories) {
      const parsedCategories = JSON.parse(savedCategories);
      console.log('Yüklenen kategoriler:', parsedCategories);
      setCategories(parsedCategories);
    }
    
    if (savedProducts) {
      const parsedProducts = JSON.parse(savedProducts);
      console.log('Yüklenen ürünler:', parsedProducts);
      setProducts(parsedProducts);
    }

    if (savedSocialLinks) {
      setSocialLinks(JSON.parse(savedSocialLinks));
    } else {
      // Varsayılan sosyal medya linkleri
      setSocialLinks([
        { id: 'discord', name: 'Discord', url: 'https://discord.gg/ZRPhecHk', icon: '💬' },
        { id: 'youtube', name: 'YouTube', url: 'https://youtube.com/@viserp', icon: '📺' },
        { id: 'instagram', name: 'Instagram', url: 'https://instagram.com/viserp', icon: '📷' },
        { id: 'tiktok', name: 'TikTok', url: 'https://tiktok.com/@viserp', icon: '🎵' }
      ]);
    }
  }, [showAdminPanel]); // Admin panel kapandığında verileri yenile

  // Admin panel açma (gizli yöntem: başlığa 5 kez tıkla)
  const handleTitleClick = () => {
    setAdminClickCount(prev => prev + 1);
    if (adminClickCount >= 4) {
      setShowAdminPanel(true);
      setAdminClickCount(0);
    }
    // 3 saniye sonra sayacı sıfırla
    setTimeout(() => setAdminClickCount(0), 3000);
  };

  const filteredProducts = activeCategory === 'all' 
    ? products 
    : products.filter(product => product.category === activeCategory);

  return (
    <div className="donate-page-new">
      {/* Animated Background */}
      <div className="animated-bg">
        <div className="floating-particles">
          {[...Array(20)].map((_, i) => (
            <div key={i} className={`particle particle-${i % 4}`}></div>
          ))}
        </div>
        <div className="grid-overlay"></div>
      </div>

      <div className="modern-container">
        <div className="modern-header">
          <div className="neon-title">
            <h1 
              className="glitch-text" 
              data-text="VISE RP MAĞAZA"
              onClick={handleTitleClick}
              style={{ cursor: 'pointer' }}
              title={adminClickCount > 0 ? `Admin: ${adminClickCount}/5` : ''}
            >
              VISE RP MAĞAZA
            </h1>
          </div>
          <p className="subtitle-glow">Modern tasarım ile oyun deneyiminizi geliştirin!</p>
          <div className="pulse-line"></div>
        </div>

        <div className="modern-layout">
          {/* Modern Kategoriler */}
          <div className="modern-categories">
            <div className="category-header">
              <h3>📂 Kategoriler</h3>
              <div className="header-glow"></div>
            </div>
            <div className="categories-grid">
              {categories.map(category => (
                <button
                  key={category.id}
                  className={`modern-category ${activeCategory === category.id ? 'active' : ''}`}
                  onClick={() => setActiveCategory(category.id)}
                >
                  <span className="category-icon-large">{category.icon}</span>
                  <span className="category-name-styled">{category.name}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Modern Ürünler */}
          <div className="modern-products">
            {filteredProducts.map(product => (
              <div key={product.id} className="modern-card">
                <div className="card-image">
                  <div className="image-bg-effect"></div>
                  <img src={product.image} alt={product.title} />
                  <div className="image-overlay">
                    <div className="pulse-ring"></div>
                  </div>
                </div>
                <div className="card-content">
                  <h4 className="product-title-glow">{product.title}</h4>
                  <p className="product-desc-fade">{product.description}</p>
                  <div className="card-features">
                    {product.features.map((feature, index) => (
                      <span key={index} className="feature-pill">
                        {feature}
                      </span>
                    ))}
                  </div>
                  <div className="card-footer">
                    <div className="price-container">
                      <div className="price-glow">{product.price}</div>
                    </div>
                    <button className="buy-button-epic">
                      <span className="button-bg"></span>
                      <span className="button-text">🛒 Satın Al</span>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>



        {/* Footer */}
        <footer className="footer-section">
          <div className="section-container">
            <div className="footer-content">
              <div className="footer-main">
                <div className="footer-brand">
                  <div className="footer-logo">
                    <span className="logo-v">V</span>
                    <span className="logo-i">I</span>
                    <span className="logo-s">S</span>
                    <span className="logo-e">E</span>
                    <span className="brand-text">ROLE<br />PLAY</span>
                  </div>
                  <p className="footer-description">
                    Türkiye'nin en kaliteli GTA 5 roleplay deneyimini sunan sunucusudur.
                  </p>
                </div>
                
                <div className="footer-links">
                  <div className="footer-column">
                    <h4>Hızlı Linkler</h4>
                    <ul>
                      <li><button onClick={onClose} className="footer-link"><i className="icon">🏠</i> Ana Sayfa</button></li>
                      <li><button onClick={onClose} className="footer-link"><i className="icon">🎮</i> Oynamaya Başla</button></li>
                    </ul>
                  </div>
                  
                  <div className="footer-column">
                    <h4>Topluluk</h4>
                    <ul>
                      {socialLinks.map(link => (
                        <li key={link.id}>
                          <button 
                            className="footer-link"
                            onClick={() => window.open(link.url, '_blank')}
                          >
                            <i className="icon">{link.icon}</i> {link.name}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                  
                  <div className="footer-column">
                    <h4>Destek</h4>
                    <ul>
                      <li><button className="footer-link"><i className="icon">💝</i> Donate</button></li>
                    </ul>
                  </div>
                  
                  <div className="footer-column">
                    <h4>Hakkımızda</h4>
                    <ul>
                      <li><button onClick={onClose} className="footer-link"><i className="icon">ℹ️</i> Hakkımızda</button></li>
                      <li><button className="footer-link"><i className="icon">📞</i> İletişim</button></li>
                    </ul>
                  </div>
                </div>
              </div>
              
              <div className="footer-bottom">
                <div className="footer-bottom-content">
                  <p className="copyright">
                    2026 VISE Roleplay • <span className="heart">❤️</span> ile geliştirildi • Tüm hakları saklıdır
                  </p>
                  <div className="footer-badges">
                    <span className="badge">🔒 Kullanım Şartları</span>
                    <span className="badge">🛡️ Gizlilik Politikası</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>

      {/* Admin Panel */}
      {showAdminPanel && (
        <AdminPanel onClose={() => setShowAdminPanel(false)} />
      )}
    </div>
  );
};

export default DonatePage;